import './css/LoginModal.css'

import { useState, useEffect } from 'react';
import github from '../assets/images/github.png';
import fish from '../assets/images/dither-beta-fish.png';

const LoginModal = ({ loginWithGithub }) => {
    const [agreed, setAgreed] = useState(false);

    const handleCheckboxChange = (e) => {
        setAgreed(e.target.checked);
    };

    useEffect(()=>{

    },[])

    return (
        <div className="login-modal">
            <header>To use Autocommitter you must:</header>
            <div className="content">
                <img className="fish" src={fish} alt="" />
                <div className="terms">
                    <input type="checkbox" id = "terms-checkbox" onChange={handleCheckboxChange} />
                    <label htmlFor="terms-checkbox">
                        I accept and agree to the&nbsp;
                        <a href="/terms-of-use">Terms Of Use</a>
                    </label>
                </div>
                <button
                    disabled={!agreed}
                    onClick={loginWithGithub}
                    className={!agreed ? 'disabled' : ''}
                >
                    <img src={github} alt="" />
                    Sign in with Github
                </button>
            </div>
        </div>
    );
};

export default LoginModal;
